import PropTypes from 'prop-types';
import React from 'react';
import ProgramImage from './ProgramImage/ProgramImage';

const HeaderInfoCourse = ({ name, classroomName, level, icon, gradient, picture, configProgramPicture }) => {
  return (
    <div className="header-info-course">
      <div className="header-info-course__container">
        <div className="header-info-course__icon-container">
          <ProgramImage configProgramPicture={configProgramPicture} iconType={icon} gradient={gradient} course_picture={picture} sizeBubble="big" />
        </div>
        <div className="header-info-course__info-container">
          <span className="header-info-course__name">{name}</span>
          <span className="header-info-course__classroomName">{classroomName}</span>
          {level && <span className="header-info-course__level">{level}</span>}
        </div>
      </div>
    </div>
  );
};

HeaderInfoCourse.propTypes = {
  name: PropTypes.string.isRequired,
  classroomName: PropTypes.string.isRequired,
  level: PropTypes.string,
  icon: PropTypes.string,
  gradient: PropTypes.string,
  picture: PropTypes.string,
  configProgramPicture: PropTypes.string,
};

HeaderInfoCourse.defaultProps = {
  level: '',
};

export default HeaderInfoCourse;
